<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ statusName() }}</strong>
                </CCardHeader>
                <CCardBody>
                    <CRow class="pl-3 pb-3" />
                    <CForm>
                        <CInput
                            v-model="status.title"
                            label="Заголовок статуса"
                            placeholder="Введите заголовок"
                        />
                        <CRow form class="form-group"> 
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Показывать как:</CCol>
                        </CRow>
                        <CCol
                            tag="label"
                            sm="3"
                            style="font-weight: 600"
                            class="col-form-label">ПРЕДОПЛАТА:</CCol>
                        <div style="margin-left: 40px">
                            <CRow>
                                <CCol
                                    tag="label"
                                    sm="3"
                                    class="col-form-label">Доставка</CCol>
                                <CCol sm="9">
                                    <CSelect
                                        inline
                                        :value.sync="status.prepayment_door"
                                        :options="status_types"
                                        placeholder="Тип статуса..."
                                    />
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol
                                    tag="label"
                                    sm="3"
                                    class="col-form-label">В точке встречи</CCol>
                                <CCol sm="9">
                                    <CSelect
                                        inline
                                        :value.sync="status.prepayment_meeting_point"
                                        :options="status_types"
                                        placeholder="Тип статуса..."
                                    />
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol
                                    tag="label"
                                    sm="3"
                                    class="col-form-label">Самовывоз</CCol>
                                <CCol sm="9">
                                    <CSelect
                                        inline
                                        :value.sync="status.prepayment_without"
                                        :options="status_types"
                                        placeholder="Тип статуса..."
                                    />
                                </CCol>
                            </CRow>
                        </div>
                        <CRow>
                            <CCol
                                tag="label"
                                style="margin-left: 20px; font-weight: 600"
                                class="col-form-label">
                                ПОСТОПЛАТА:
                            </CCol> 
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="status.postpaid"
                                />
                            </CCol>
                        </CRow>
                        <div
                            v-if="status.postpaid"
                            style="margin-left: 40px">
                            <CRow>
                                <CCol
                                    tag="label"
                                    sm="3"
                                    class="col-form-label">Доставка</CCol>
                                <CCol sm="9">
                                    <CSelect
                                        inline
                                        :value.sync="status.postpaid_door"
                                        :options="status_types"
                                        placeholder="Тип статуса..."
                                    />
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol
                                    tag="label"
                                    sm="3"
                                    class="col-form-label">В точке встречи</CCol>
                                <CCol sm="9">
                                    <CSelect
                                        inline
                                        :value.sync="status.postpaid_meeting_point"
                                        :options="status_types"
                                        placeholder="Тип статуса..."
                                    />
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol
                                    tag="label"
                                    sm="3"
                                    class="col-form-label">Самовывоз</CCol>
                                <CCol sm="9">
                                    <CSelect
                                        inline
                                        :value.sync="status.postpaid_without"
                                        :options="status_types"
                                        placeholder="Тип статуса..."
                                    />
                                </CCol>
                            </CRow>
                        </div>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Отслеживает
                            </CCol> 
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="status.enabled"
                                />
                            </CCol>
                        </CRow>
                    </CForm>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save"
                    >Сохранить</CButton
                    >
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack"
                    >Назад</CButton
                    >
                    <CButton
                        v-if="status.id"
                        color="danger"
                        class="mr-3"
                        @click="deleteModal = true"
                    >Очистить</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>

        <CModal
            title="Подтверждение"
            color="danger"
            :show.sync="deleteModal"
            :footer="false"
        >
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <p>
                        Вы действительно хотите очистить данные статуса? Это действие
                        нельзя будет отменить.
                    </p>
                </div>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="deleteModal = false"
                    >Отмена</CButton
                    >
                    <CButton
                        color="danger"
                        class="ml-3"
                        @click="deleteEntity"
                    >Очистить</CButton
                    >
                </div>
            </template>
        </CModal>
    </CRow>
</template>

<script>
    import { orderStatusTitle } from '@/utils/order-views';
    import { STATUS_DIALOGS_TYPES } from '@/utils/order';

    export default {
        name: 'StatusDialogStatus',

        data: () => ({
            status: {
                id: null,
                status: null,
                entity_id: null,
                entity_type: '',
                title: '',
                text: '',
                picture: '',
                picture_success: '',
                enabled: false,
                prepayment_door: null,
                prepayment_meeting_point: null,
                prepayment_without: null,
                postpaid_door: null,
                postpaid_meeting_point: null,
                postpaid_without: null,
                postpaid: false,
            },
            deleteModal: false,
            status_types: [],
        }),

        computed: {
            pictureUrl() {
                if (this.status.picture) {
                    return (
                        process.env.VUE_APP_STATIC_BASE_URL +
                        '/' +
                        this.status.picture
                    );
                } else {
                    return '';
                }
            },
            successPictureUrl() {
                if (this.status.picture_success) {
                    return (
                        process.env.VUE_APP_STATIC_BASE_URL +
                        '/' +
                        this.status.picture_success
                    );
                } else {
                    return '';
                }
            },
            adminOnly() {
                return !JSON.parse(localStorage.getItem('settings')).is_business_admin;
            },
        },

        async mounted() {
            await this.fetchStatus();
        },

        methods: {
            async fetchStatus() {
                try {
                    const serviceName = this?.$route?.fullPath?.split('/')[2].replace(/s$/g, '');
                    const _params = {
                        status: this.$route.params.status,
                        type: serviceName,
                    };
                    const { data } = await this.axios.get('/status', { params: _params });
                    if (data.id) {
                        this.status = data;
                    }
                    if (this.status_types) {
                        const types = [];
                        types.push({ value: 0, label: 'Ничего' });
                        if (serviceName === 'restaurant') {
                            types.push({ value: STATUS_DIALOGS_TYPES.NOT_PAID, label: 'Не оплачен' });
                            types.push({ value: STATUS_DIALOGS_TYPES.COOKING, label: 'Готовим' });
                            types.push({ value: STATUS_DIALOGS_TYPES.AWAITING_READY, label: 'Готов к выдаче в ресторане' });
                            types.push({ value: STATUS_DIALOGS_TYPES.CANCELED, label: 'Отменен' });
                            types.push({ value: STATUS_DIALOGS_TYPES.DELIVERY, label: 'Консьерж в пути' });
                            types.push({ value: STATUS_DIALOGS_TYPES.MEETING_POINT, label: 'Готов к выдаче в точке встречи' });
                            types.push({ value: STATUS_DIALOGS_TYPES.DONE, label: 'Доставлен' });
                            types.push({ value: STATUS_DIALOGS_TYPES.COMPLETED, label: 'Уже у вас' });
                            types.push({ value: STATUS_DIALOGS_TYPES.DELIVERED_DOOR, label: 'Доставлен до двери' });

                        } else if (serviceName === 'grocer') {
                            types.push({ value: STATUS_DIALOGS_TYPES.NOT_PAID, label: 'Не оплачен' });
                            types.push({ value: STATUS_DIALOGS_TYPES.AWAITING, label: 'Собираем' });
                            types.push({ value: STATUS_DIALOGS_TYPES.DELIVERY, label: 'Консьерж в пути' });
                            types.push({ value: STATUS_DIALOGS_TYPES.DONE, label: 'Доставлен' });
                            types.push({ value: STATUS_DIALOGS_TYPES.CANCELED, label: 'Отменен' });
                            types.push({ value: STATUS_DIALOGS_TYPES.AWAITING_READY, label: 'Готов к выдаче в магазине' });
                            types.push({ value: STATUS_DIALOGS_TYPES.MEETING_POINT, label: 'Готов к выдаче в точке встречи' });
                            types.push({ value: STATUS_DIALOGS_TYPES.NOT_PAID_POST, label: 'Заказ принят' });
                            types.push({ value: STATUS_DIALOGS_TYPES.COMPLETED, label: 'Уже у вас' });
                            types.push({ value: STATUS_DIALOGS_TYPES.DELIVERED_DOOR, label: 'Доставлен до двери' });
                        } else {
                            types.push({ value: STATUS_DIALOGS_TYPES.NOT_PAID_POST, label: 'Заказ принят' });
                            types.push({ value: STATUS_DIALOGS_TYPES.NOT_PAID, label: 'Не оплачен' });
                            types.push({ value: STATUS_DIALOGS_TYPES.AWAITING, label: 'Собираем' });
                            types.push({ value: STATUS_DIALOGS_TYPES.COOKING, label: 'Готовим' });
                            types.push({ value: STATUS_DIALOGS_TYPES.IN_WORK, label: 'В работе' });
                            types.push({ value: STATUS_DIALOGS_TYPES.DELIVERY, label: 'Консьерж в пути' });
                            types.push({ value: STATUS_DIALOGS_TYPES.DONE, label: 'Доставлен' });
                            types.push({ value: STATUS_DIALOGS_TYPES.CANCELED, label: 'Отменен' });
                            types.push({ value: STATUS_DIALOGS_TYPES.AWAITING_READY, label: 'Готов к выдаче' });
                            types.push({ value: STATUS_DIALOGS_TYPES.MEETING_POINT, label: 'В точке встречи' });
                            types.push({ value: STATUS_DIALOGS_TYPES.COMPLETED, label: 'Уже у вас' });
                            types.push({ value: STATUS_DIALOGS_TYPES.DELIVERED_DOOR, label: 'Доставлен до двери' });
                        }
                        this.status_types = types;
                    }
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                }
            },

            async save() {
                try {
                    this.status.status = +this?.$route?.params?.status;
                    this.status.entity_type = this?.$route?.fullPath?.split('/')[2].replace(/s$/g, '');

                    if (this.status.entity_type === 'entities') {
                        this.status.entity_id = this?.$route?.fullPath?.split('/')[3];;
                    }
                    this.status.postpaid = !!this.status.postpaid;

                    await this.axios.post('/status',this.status);
                    this.goBack();
                } catch (error) {
                    this.$root.$emit('showError', 'Ошибка сохранения.');
                }
            },

            deleteEntity() {
                this.axios
                    .delete('/status/' + this.status.id)
                    .then(() => {
                        this.goBack();
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка удаления.');
                    });
            },

            statusName() {
                return orderStatusTitle(+this?.$route?.params?.status)
            },

            goBack() {
                this.$router.go(-1);
            },
        }
    }
</script>
